<header></header>
<ion-content>
    <ion-grid>
        <ion-row class="ion-justify-content-center">
            <ngx-spinner [name]='"loginspinner"'></ngx-spinner>
            <ion-col size="12" size-md="6" size-lg="4">
                @switch (websocket.status) {
                <!-- Sent authentication request; waiting for response -->
                @case ('authenticating') {
                <ion-card>
                </ion-card>
                }
                <!-- Login is required. Waiting for credentials input -->
                @case ('waiting for credentials') {
                <ion-card>
                    <ion-item color="primary" lines="full">
                        <ion-icon slot="start" name="person-outline"></ion-icon>
                        <ion-label>{{"LOGIN.TITLE" | translate}}</ion-label>
                    </ion-item>
                    <!-- OpenEMS Edge Login -->
                    @if (environment.backend === 'OpenEMS Edge') {
                    <ion-card-content>
                        <form (ngSubmit)="doLogin({ password: password.value})">
                            <div class="ion-padding">
                                <ion-item>
                                    <ion-text class="ion-text-wrap" color="medium" translate>
                                        LOGIN.PREAMBLE
                                    </ion-text>
                                </ion-item>
                                <ion-item>
                                    <ion-input #password required type="password"
                                        [label]="'LOGIN.PASSWORD_LABEL' | translate" label-placement="floating"
                                        [placeholder]="'LOGIN.PASSWORD_LABEL' | translate" value="user"></ion-input>
                                </ion-item>
                                <!-- workaround for submit with enter key https://github.com/ionic-team/ionic-framework/issues/19368 -->
                                <input type="submit" style="visibility: hidden; position: absolute; position: -999px" />
                                <ion-button [disabled]="formIsDisabled" type="submit" class="ion-float-right">
                                    <ion-icon slot="icon-only" name="log-in-outline"></ion-icon>
                                </ion-button>
                            </div>
                        </form>
                    </ion-card-content>
                    }
                    <!-- OpenEMS Backend Login -->
                    @if (environment.backend === 'OpenEMS Backend') {
                    <ion-card-content>
                        <form (ngSubmit)="doLogin({ username: username.value, password: password.value})">
                            <ion-item>
                                <ion-input #username required type="input"
                                    [placeholder]="'E-Mail / ' + ('LOGIN.USER' | translate)"
                                    [label]="'E-Mail / '  + ('LOGIN.USER' | translate)" label-placement="floating">
                                </ion-input>
                            </ion-item>
                            <ion-item>
                                <ion-input #password required type="password"
                                    [placeholder]="'LOGIN.PASSWORD_LABEL' | translate" label-placement="floating"
                                    [label]="'LOGIN.PASSWORD_LABEL' | translate">
                                </ion-input>
                            </ion-item>
                            <!-- workaround for submit with enter key https://github.com/ionic-team/ionic-framework/issues/19368 -->
                            <input type="submit" style="visibility: hidden; position: absolute; position: -999px" />
                            <ion-item lines="none" class="ion-margin-top">
                                <table class=" full_width">
                                    <tr>
                                        <th>
                                    <tr>
                                        <a class="ion-float-left" size="small"
                                            [href]="environment.links.FORGET_PASSWORD" style="text-decoration: none;">
                                            <small translate>LOGIN.PASSWORD_RESET</small>
                                        </a>
                                    </tr>
                                    @if (!isApp) {
                                    <tr>
                                        <registration style="cursor: pointer;"></registration>
                                    </tr>
                                    }
                                    </th>
                                    <th>
                                        <ion-button [disabled]="formIsDisabled" type="submit" class="ion-float-right"
                                            size="medium">
                                            <small>Login</small>
                                            <ion-icon slot="end" name="log-in-outline"></ion-icon>
                                        </ion-button>
                                    </th>
                                    </tr>
                                </table>
                            </ion-item>
                        </form>
                    </ion-card-content>
                    }
                </ion-card>
                }
                }
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>